'use client';

import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { Container } from './Container';
import styles from './FAQSection.module.css';

export const FAQElement = ({
  className,
  title,
  description,
}: {
  className?: string;
  title: string | React.ReactNode;
  description: React.ReactNode;
}) => {
  return (
    <div
      className={[styles.faqElement, className, 'faq-element']
        .filter(Boolean)
        .join(' ')}
    >
      {title ? <h5>{title}</h5> : null}
      <div className={`description ${title ? '' : 'text-center'}`}>
        {description}
      </div>
    </div>
  );
};

export const FAQSection = ({
  className,
  faqData,
  bgColor = 'black',
  htmlId,
  pb,
  disclaimerText,
  heading,
  'aria-label': ariaLabel,
}: {
  className?: string;
  faqData: {
    title: string | React.ReactNode;
    description: React.ReactNode;
  }[];
  bgColor?: 'white' | 'black' | 'grey';
  htmlId?: string;
  pb?: 'pb-0';
  disclaimerText?: React.ReactNode;
  heading?: React.ReactNode;
  'aria-label'?: string;
}) => {
  const t = useTranslations('common');
  const rootRef = useRef<HTMLDivElement>(null);
  return (
    <section
      className={[styles.root, className, bgColor, pb].filter(Boolean).join(' ')}
      id={htmlId}
      ref={rootRef}
      aria-label={ariaLabel}
    >
      <Container className="container">
        <h2 className={styles.h2}>{heading ?? t('ring.faq.head')}</h2>
        <div className="faq-container">
          {faqData.map((faq, i) => {
            return <FAQElement key={i} {...faq} />;
          })}
        </div>
        {disclaimerText && <p className="faq-disclaimer">{disclaimerText}</p>}
      </Container>
    </section>
  );
};
